import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component ClockStopwatchSmallIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <ClockStopwatchSmallIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <ClockStopwatchSmallIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ClockStopwatchSmallIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ClockStopwatchSmallIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        d="M5.5.9a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm0 1a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm.515 1v4H5v-4h1.015zM9.797 0l2.152 2.121-.717.707L9.08.708 9.797 0z"
        fillRule="evenodd"
      />
    </svg>
  )
);
ClockStopwatchSmallIcon.displayName = "ClockStopwatchSmallIcon";
export default ClockStopwatchSmallIcon;
